import React, { PropTypes, Component } from 'react'
import cx from 'classnames'

import './CancelBooking.scss'
import MobileNavBar from 'components/MobileNavBar'
import MobileNavBarBackButton from 'components/MobileNavBarBackButton'
import ModifyingServiceLoader from 'components/ModifyingServiceLoader'
import { userNextServices } from 'utils/paths'

class CancelBooking extends Component {
  constructor (props) {
    super(props)

    this.state = {
      penaltyFetched: false
    }

    this.bookingName = 'reservación' // Override this property

    this.cancelBooking = this.cancelBooking.bind(this)
    this.onPenaltyFetched = this.onPenaltyFetched.bind(this)
  }

  componentDidMount () {
    const { bookingId } = this.props
    this.fetchBooking(bookingId)
  }

  fetchBooking (id) {
    const { fetchBooking } = this.props
    fetchBooking(id)
  }

  cancelBooking () {
    const {
      cancelBooking,
      bookingId,
      push,
      params: {
        userId
      }
    } = this.props

    const nextUrl = userNextServices(userId)
    cancelBooking(bookingId, () => push(nextUrl))
  }

  onPenaltyFetched () {
    if (this.state.penaltyFetched === false) {
      this.setState({
        penaltyFetched: true
      })
    }
  }

  isLoading () {
    const { fetchingBooking, booking } = this.props
    return fetchingBooking || !booking
  }

  renderPenalty () {
    // Override this function
  }

  renderInfo () {
    // Override this function
  }

  render () {
    const loading = this.isLoading()

    const {
      booking,
      bookingId,
      cancellingBooking
    } = this.props

    const {
      penaltyFetched
    } = this.state

    const cancelBookingButtonClassName = cx(
      'CancelBooking-cancelBookingButton',
      'btn btn-primary btn-lg btn-block',
      {
        disabled: cancellingBooking || !penaltyFetched
      }
    )

    return (
      <div className='CancelBooking navbar-screen'>
        <MobileNavBar
          leftControl={<MobileNavBarBackButton />}
          rightControl={<span className='icon-logo' />}
        >
          Cancelar {this.bookingName}
        </MobileNavBar>
        <ModifyingServiceLoader
          isOpen={cancellingBooking}
          text='Cancelando...'
          />

        {!loading &&
          <div className='CancelBooking-content navbar-screen-content'>
            <div className='CancelBooking-contentCard'>
              <div className='CancelBooking-cardTitle'>
                Cancelar {this.bookingName}
              </div>
              <div className='CancelBooking-contentBody'>
                { this.renderInfo({ booking }) }

                { this.renderPenalty({bookingId, onPenaltyFetched: this.onPenaltyFetched}) }

                <p>
                  ¿Estás seguro de que quieres realizar este cambio?
                </p>
              </div>
              <div className='CancelBooking-buttons'>
                <button
                  className={cancelBookingButtonClassName}
                  onClick={this.cancelBooking}
                  disabled={cancellingBooking || !penaltyFetched}
                  >
                  Cancelar {this.bookingName}
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

CancelBooking.displayName = 'CancelBooking'
CancelBooking.propTypes = {
  booking: PropTypes.object,
  bookingId: PropTypes.number.isRequired,
  cancelBooking: PropTypes.func.isRequired,
  cancellingBooking: PropTypes.bool.isRequired,
  fetchingBooking: PropTypes.bool.isRequired,
  params: PropTypes.shape({
    userId: PropTypes.string.isRequired
  }).isRequired
}
CancelBooking.defaultProps = {}

export default CancelBooking



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/CancelBooking/CancelBooking.js